import { setAwaitingServiceResponse } from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';
import getFullComposeViewState from '../../selectors/getFullComposeViewState';

export default mutator(setAwaitingServiceResponse, actionMessage => {
    const fullComposeViewState = getFullComposeViewState();
    fullComposeViewState.awaitingServiceResponse = actionMessage.awaitingServiceResponse;
});
